export default function(instance) {
    return {
        getHistory(params) {
            return instance.get('/api/v2/saleHistory', {params})
        },
        getFinancialOperations(params) {
            return instance.get('/api/v2/financialOperations', { params })
        }
    }
}